export const TITLE = "United States Clinical Development";

export const INDICATION_TOOLTIP =
  "Indications followed by * signal that the FDA approved indication may be restricted or more narrow (e.g., a subpopulation). For the FDA approved indication please see the prescribing information.";

export const SUB_TOOLTIP = "Anticipated Submission Type";

export const PDF_REPORT_TOOLTIP =
  'Refine your search by selecting filters from the "Show All Filters" tab and/or using the "Jump To" buttons. Once you identify the data set you are looking for, create your custom report.';
export const ICONS = {
  financialForecasts: "Market & Financial Insights",
  lci: "Life-Cycle Insights",
  ppi: "Payer & Provider Insights",
  budgetImpacts: "Budget Impact Models",
  magGlass: "View Additional Drug Data",
  export: "Export as CSV",
  pdf: "Export as PDF",
};
